// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'font-awesome/css/font-awesome.css'
import { Settings } from 'luxon'

import { mountComponents, unmountComponents } from "../util/mountComponents"
import i18n from '../application/utils/i18n'
import { forgetFormState, hasUnsavedInput, rememberFormState } from '../application/utils/unsavedInput'

// Initialize Luxon with default settings
// These can be overridden by the view template if needed
Settings.defaultLocale = document.documentElement.lang || 'en';
Settings.defaultZone = document.documentElement.dataset.timezone || 'UTC';

// Expose luxon to window for global access
window.luxon = { Settings };

// Expose i18n to window for assets pipeline compatibility
// Will be removed once we moved everything to shakapacker
window.I18n = i18n

// Same reason: Widgets.Modal lives in the Sprockets bundle and needs the dirty check Modal.jsx
// uses, so that Escape means the same thing in both dialogs.
window.DownTheDrain = { ...window.DownTheDrain, forgetFormState, hasUnsavedInput, rememberFormState }

// Make components available for react_component helper
const componentsContext = require.context(
  "../application/components",
  true,
  /(?<!(test|test\.[jt]sx?|\.scss))$/, // Exclude tests and scss files
)

// Called, not referenced: as a listener it would be handed the event as its `root`.
document.addEventListener('turbolinks:before-cache', () => unmountComponents());
document.addEventListener('turbolinks:load', () => {
    mountComponents(componentsContext)
})
document.addEventListener('react:mount_components', () => {
  mountComponents(componentsContext)
})
document.addEventListener('react:unmount_components', (event) => {
  const selector = event.detail && event.detail.selector
  const root = selector && document.querySelector(selector)

  unmountComponents(root || document)
})
